































import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {Component, Prop} from "vue-property-decorator";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";

@Component({
    name: "ManageCodCustomerTable",
    components: {TooltipLabel, LadingStatusLabel}
})
export default class extends mixins(CommonMixin) {
    @Prop({ required: true }) readonly columns: any;
    @Prop({ required: true }) readonly dataSource: any;
    @Prop({ required: true }) readonly pagination: any;

    onChangePage(pagination: any) {
        this.$emit('change', pagination);
    }
}
